import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

export function useBrandSearch(
  teamId: string,
  onSuccess: (data: { brands: Api.Brand[] } | ResponseObject) => void
) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    data = {},
    error,
    isLoading,
    refetch
  } = useQuery({
    queryKey: 'team-brands',
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${teamId}/brands/search`,
        token
      }).then((response: { brands: Api.Brand[] } | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        if (onSuccess) {
          onSuccess(response);
        }
        return response;
      })
    // enabled: false
  });

  return {
    isLoading,
    refetch,
    error,
    data
  };
}
